import { render, staticRenderFns } from "./editReview.vue?vue&type=template&id=1214b8ab&scoped=true"
import script from "./editReview.vue?vue&type=script&lang=js"
export * from "./editReview.vue?vue&type=script&lang=js"
import style0 from "./editReview.vue?vue&type=style&index=0&id=1214b8ab&prod&lang=css"
import style1 from "./editReview.vue?vue&type=style&index=1&id=1214b8ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214b8ab",
  null
  
)

export default component.exports